import React, { useState } from 'react';
import { useImmutableCallback } from '@agro1desenvolvimento/react-hooks';
import Modal from '../../components/Modal/modal';
import Agro1Loader from '../../components/Agro1Loader';
import Agro1Toast from '../../components/Agro1Toast';
import {
  AqilaRecomendacoesService,
  RecomendacoesService,
} from '../../services';
import usePendingApprovesStore from './store';

interface DeleteRecomendacaoModalProps {
  visible: boolean;
  id: number;
  onHide: () => void;
  aqilaRecomendacao?: boolean;
}

const DeleteRecomendacaoModal: React.FC<DeleteRecomendacaoModalProps> = ({
  visible,
  id,
  onHide,
  aqilaRecomendacao = false,
}) => {
  const [motivoRejeicao, setMotivoRejeicao] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const refreshAproves = usePendingApprovesStore(
    (state) => state.refreshAproves,
  );

  const onConfirm = useImmutableCallback(async () => {
    const loaderId = Agro1Loader.show();
    setIsLoading(true);

    try {
      if (aqilaRecomendacao) {
        await AqilaRecomendacoesService.rejeitar(id, motivoRejeicao);
      } else {
        await RecomendacoesService.rejeitar(id, motivoRejeicao);
      }

      Agro1Toast.show({
        detail: 'Recomendação rejeitada com sucesso.',
        severity: 'success',
      });
      await refreshAproves();
      onHide();
    } catch (error) {
      console.error(error);

      Agro1Toast.show({
        detail: 'Falha ao rejeitar a recomendação.',
        severity: 'error',
        sticky: true,
      });
    } finally {
      Agro1Loader.close(loaderId);
      setIsLoading(false);
    }
  });

  return (
    <Modal
      visible={visible}
      title={`Motivo da Rejeição ${id}`}
      className="pending-aprove-item-modal"
      position="top"
      content={
        <div>
          <input
            type="text"
            className="pending-aprove-item-modal-motivo"
            value={motivoRejeicao}
            onChange={(e) => setMotivoRejeicao(e.target.value)}
            placeholder="Informe o motivo da rejeição"
          />
        </div>
      }
      actionsClassName="pending-aprove-item-modal-footer"
      actions={[
        {
          label: 'Cancelar',
          onClick: onHide,
          buttonProps: {
            className:
              'pending-aprove-item-modal-action pending-aprove-item-modal-action-cancel',
          },
        },
        {
          label: 'Ok',
          onClick: onConfirm,
          buttonProps: {
            className:
              'pending-aprove-item-modal-action pending-aprove-item-modal-action-verify',
            loading: isLoading,
            disabled: isLoading,
          },
        },
      ]}
      onHide={onHide}
    />
  );
};

export default React.memo(DeleteRecomendacaoModal);
